import { Link } from 'react-router-dom';
import { articlesData } from '@/mocks/articles';

const previewArticles = articlesData.filter((a) => a.slug !== 'sugargoo-spreadsheet-guide').slice(0, 9);

export default function ArticlesPreview() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            Latest <strong className="text-accent-600">Sugargoo Spreadsheet</strong> Articles & Guides
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Expert-written SEO articles covering everything from Sugargoo reviews and shipping guides to money-saving tips and product discovery strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {previewArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.01] transition-all duration-300"
            >
              <div className="aspect-[16/10] w-full overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full mb-3 whitespace-nowrap">
                  {article.category}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.subtitle}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}